const stringifyParams = object => {
  const queryString = new URLSearchParams(object).toString();

  return queryString;
};

export default stringifyParams;
